// Module to hold functions to assist working with localStorage
import config from 'shared/config';

/**
 * Check if localStorage.setItem is enabled
 */
const isSetItemEnable = () => {
	try {
		localStorage.setItem('enabled', 'true');
		const enabled = localStorage.getItem('enabled') === 'true';
		localStorage.removeItem('enabled');
		config.SET_ITEM_ENABLED = enabled;
	} catch (exception) {
		config.SET_ITEM_ENABLED = false;
	}
};

export default isSetItemEnable;
